export default __webpack_public_path__ + "static/media/mekong.3d63e57a.png";